
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"39","height":"39","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"14.414","y":"13.314","width":"16","height":"2","rx":"1","transform":"rotate(45 14.414 13.314)"}}),_c('rect',{attrs:{"x":"13.414","y":"24.314","width":"16","height":"2","rx":"1","transform":"rotate(-45 13.414 24.314)"}})])
          )
        }
      }
    